import { Controller, set, useForm } from "react-hook-form";
import { useState } from "react";
import axios from "axios";
import { TextField, Button, Input, InputAdornment, IconButton } from "@mui/material";
import { Select, MenuItem } from "@mui/material";
import { DownloadOutlined } from "@mui/icons-material";
import { Clear } from '@mui/icons-material';
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useToast } from "../Toast/Toast";
import { useNavigate } from "react-router-dom";
import CustomTextField from "../Ui/CustomTextField";
import CustomSelectField from "../Ui/CustomSelectField";

export const AddCell = ({ mode }) => {
  const { cellId } = useParams();
  const showToast = useToast();
  const navigator = useNavigate();

  const [cellData, setCellData] = useState({
    cell_condition: "New",
    manufacturer: "Samsung",
    model: "25R",
    mass: "10g",
    volume: "10mm^3",
    height: "10cm",
    diameter: "10mm",
    formFactor: "18650",
    type: "Cylindrical",
    price: "10$",
    nominal_voltage: "3.7V",
    nominal_energy: "10Wh",
    nominal_charge_capacity: "2.5Ah",
    voltage_range: "9V-4.2V",
    current_continuous: "20A",
    peak_current: "25A",
    power_continuous: "50W",
    power_peak: "60W",
    energy_density_galvanometric: "200Wh/kg",
    energy_density_volumetric: "200Wh/L",
    power_density_galvanometric: "200W/kg",
    power_density_volumetric: "200W/L",
    soh: "100%",
    capacity: "2.5Ah",
    cell_characterization_date: "2022-01-01",
    cell_image: "",
    cell_impedance_csv: "",
    cell_hppc_csv: "",
    cell_cycle_csv: "",
  });
  const [imagePreview, setImagePreview] = useState("");
  const [csvPreview, setCsvPreview] = useState("");
  const [csvPreview1, setCsvPreview1] = useState("");
  const [csvPreview2, setCsvPreview2] = useState("");

  useEffect(() => {
    if (cellId) {
      axios.get(`${process.env.BACKEND_URL}batteries/id/${cellId}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        setCellData(res.data);
        setImagePreview(`${process.env.BACKEND_URL}files/${res.data.cell_image}`);
        setCsvPreview(`${process.env.BACKEND_URL}files/${res.data.cell_impedance_csv}`);
        setValue("cell_image", `${process.env.BACKEND_URL}files/${res.data.cell_image}`);
        setValue("cell_impedance_csv", `${process.env.BACKEND_URL}files/${res.data.cell_impedance_csv}`);
      });
    }
  }, [cellId]);

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: cellData,
  });

  useEffect(() => {
    if (cellData) {
      setValue("cell_condition", cellData.cell_condition);
      setValue("manufacturer", cellData.manufacturer);
      setValue("model", cellData.model);
      setValue("mass", cellData.mass);
      setValue("volume", cellData.volume);
      setValue("height", cellData.height);
      setValue("diameter", cellData.diameter);
      setValue("formFactor", cellData.formFactor);
      setValue("type", cellData.type);
      setValue("price", cellData.price);
      setValue("nominal_voltage", cellData.nominal_voltage);
      setValue("nominal_energy", cellData.nominal_energy);
      setValue("nominal_charge_capacity", cellData.nominal_charge_capacity);
      setValue("voltage_range", cellData.voltage_range);
      setValue("current_continuous", cellData.current_continuous);
      setValue("peak_current", cellData.peak_current);
      setValue("power_continuous", cellData.power_continuous);
      setValue("power_peak", cellData.power_peak);
      setValue("energy_density_galvanometric", cellData.energy_density_galvanometric);
      setValue("energy_density_volumetric", cellData.energy_density_volumetric);
      setValue("power_density_galvanometric", cellData.power_density_galvanometric);
      setValue("power_density_volumetric", cellData.power_density_volumetric);
      setValue("soh", cellData.soh);
      setValue("capacity", cellData.capacity);
      setValue("cell_characterization_date", cellData.cell_characterization_date);
      setValue("cell_image", cellData.cell_image);
      setValue("cell_impedance_csv", cellData.cell_impedance_csv);
      setValue("cell_hppc_csv", cellData.cell_hppc_csv);
      setValue("cell_cycle_csv", cellData.cell_cycle_csv);
    }
  }, [cellData, setValue]);


  const submitData = async (data) => {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });
    if (cellId) {
      const resp = await axios.put(`${process.env.BACKEND_URL}batteries/id/${cellId}`, formData, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      if (resp.data.error) {
        showToast("Error updating cell", "error");
        return;
      } else {
        showToast("Cell updated successfully", "success");
        navigator("/auth/cellStore/" + resp.data.battery_id);
      }
      return;
    }
    const resp = await axios.post(`${process.env.BACKEND_URL}batteries`, formData, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    if (resp.data.error) {
      return;
    } else {
      showToast("Cell added successfully", "success");
      navigator("/auth/cellStore/" + resp.data.battery_id);
    }
  };
  return (
    <div className="flex flex-col items-center gap-8 p-8">
      <h1 className="text-xl text-[#e8442d] text-center md:text-xxl lg:text-3xl">
        Enter Battery Details
      </h1>
      <form
        onSubmit={handleSubmit(submitData)}
        className="w-[100%] md:w-[80%] flex flex-col gap-8 items-center shadow-[0px_0px_11px_0px_#e8442d] p-6 max-w-[1000px] rounded-lg"
      >
        <div className="w-full flex flex-col justify-center items-start gap-1">
          <label className="text-[#e8442d] text-sm p-2 font-light" htmlFor="cellImage">
            Upload Cell Image *
          </label>
          <Input
            id="cellImage"
            required
            type="file"
            fullWidth
            variant="filled"
            multiple={false}
            disableUnderline
            onChange={(e) => {
              const file = e.target.files[0];
              setCellData((prev) => {
                return {
                  ...prev,
                  cell_image: file,
                };
              }
              );
              const previewURL = URL.createObjectURL(file);
              setImagePreview(previewURL);
              document.getElementById('cellImageLabel').innerText = file.name;
            }}
            error={errors.cell_image ? true : false}
            inputProps={{ accept: "image/*", id: "cellImageLabel", style: { color: "#e8442d", fontWeight: "900" }, placeholder: "Upload Cell Image" }}
            endAdornment={
              imagePreview && (
                <InputAdornment position="start">
                  <img src={imagePreview} alt="Selected Image" style={{ width: "50px", height: "50px" }} />
                  <IconButton onClick={() => {
                    setCellData((prev) => {
                      return {
                        ...prev,
                        cell_image: "",
                      };
                    });
                    setImagePreview("");
                  }}>
                    <Clear />
                  </IconButton>
                </InputAdornment>
              )
            }
            sx={{
              '& .MuiInputBase-input': {
                border: '1px solid #e8442d',
                borderRadius: '5px',
                padding: '10px',
                color: "#000",
                cursor: 'pointer',
                '&::placeholder': {
                  color: '#e8442d',
                  fontWeight: '900',
                },
              },
              '& .MuiIconButton-root': {
                color: '#e8442d',
              },
              '& .MuiInputBase-root': {
                backgroundColor: 'white',
              },
              '& .MuiInputBase-input::placeholder': {
                color: '#e8442d',
                fontWeight: '900',
              }
            }}
          />
        </div>
        
        <Controller
          name="cell_condition"
          control={control}
          render={({ field }) => (
            <CustomSelectField field={field} data={['New', 'Used']} label="Cell Condition" defaultLabel="Select Cell Condition" />
          )}
        />

        <Controller   
          name="manufacturer"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="Manufacturer" />
          )}
        />

        <Controller
          name="model"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="Model" />
          )}
        />

        <Controller
          name="type"
          control={control}
          render={({ field }) => (
            <CustomSelectField field={field} data={['Cylindrical', 'Prismatic', 'Pouch']} label="Cell Type" defaultLabel="Select Cell Type" />
          )}
        />  

        <Controller
          name="formFactor"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="Form Factor" />
          )}
        />

        <Controller
          name="mass"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="Mass (in g)" />
          )}
        />

        <Controller
          name="price"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="Price (in $)" />
          )}
        />

        <Controller
          name="height"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="Height (in cm)" />
          )}
        />

        <Controller
          name="diameter"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="Diameter (in mm)" />
          )}
        />

        <Controller
          name="volume"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="Volume (in mm^3)" />
          )}
        />

        <Controller
          name="nominal_voltage"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="Nominal Voltage (in V)" />
          )}
        />

        <Controller
          name="nominal_energy"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="Nominal Energy (in Wh)" />
          )}

        />

        <Controller
          name="nominal_charge_capacity"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="Nominal Charge Capacity (in Ah)" />
          )}
        />

        <Controller 
          name="voltage_range"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="Voltage Range (in V)" />
          )}
        />

        <Controller
          name="current_continuous"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="Continuous Current (in A)" />
          )}
        />

        <Controller
          name="peak_current"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="Peak Current (in A)" />
          )}
        />

        <Controller
          name="power_continuous"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="Continuous Power (in W)" />
          )}
        />

        <Controller
          name="power_peak"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="Peak Power (in W)" />
          )}
        />

        <Controller
          name="energy_density_galvanometric"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="Energy Density Galvanometric (in Wh/kg)" />
          )}
        />

        <Controller
          name="energy_density_volumetric"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="Energy Density Volumetric (in Wh/L)" />
          )}

        />

        <Controller
          name="power_density_galvanometric"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="Power Density Galvanometric (in W/kg)" />
          )}
        />

        <Controller
          name="power_density_volumetric"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="Power Density Volumetric (in W/L)" />
          )}
        />

        <Controller
          name="soh"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="State of Health (%)" />
          )}
        />

        <Controller
          name="capacity"
          control={control}
          render={({ field }) => (
            <CustomTextField field={field} errors={errors} reqs={true} label="Capacity (in Ah)" />
          )}
        />

      <div className="w-full flex flex-col justify-center items-start gap-1">
        <label className="text-[#e8442d] text-sm p-2 font-thin" htmlFor="cell_characterization_date">
          Cell Characterisation Date *
        </label>
        <Controller
          name= "cell_characterization_date"
          control={control}
          render={({ field }) => (
            <TextField
              required
              fullWidth
              variant="filled"
              type="date"
              {...field}
              onChange={(e) => {
                field.onChange(e);
              }}
              error={errors.cell_characterization_date ? true : false}
              inputProps={{ style: { color: "#e8442d", fontWeight: "900" } }}
              sx={{
                '& .MuiInputBase-input': {
                  border: '1px solid #e8442d',
                  borderRadius: '5px',
                  padding: '10px',
                  color: "#000",
                  cursor: 'pointer',
                  '&::placeholder': {
                    color: '#e8442d',
                    fontWeight: '900',
                  },
                },
                '& .MuiInputBase-root': {
                  backgroundColor: 'white',
                },
                '& .MuiInputBase-input::placeholder': {
                  color: '#e8442d',
                  fontWeight: '900',
                }
              }}
            />
          )}
        />
      </div>


        <div className="w-full flex flex-col justify-center items-start gap-1">
          <label className="text-[#e8442d] text-sm p-2 font-thin" htmlFor="cellImpedanceCsv">
            Upload Cell Impedance csv *
          </label>
          <Input
            id="cellImpedanceCsv"
            required
            type="file"
            fullWidth
            variant="filled"
            multiple={false}
            disableUnderline
            onChange={(e) => {
              const file = e.target.files[0];
              setCellData((prev) => {
                return {
                  ...prev,
                  cell_impedance_csv: file,
                };
              }
              );
              const previewURL = URL.createObjectURL(file);
              setCsvPreview(previewURL);
              document.getElementById('cellImpedanceCsv').innerText = file.name;
            }}
            error={errors.cell_impedance_csv ? true : false}
            inputProps={{ accept: "text/csv", id: "cellImpedanceCsv", style: { color: "#e8442d", fontWeight: "900" }, placeholder: "Upload Cell Impedance csv" }}
            endAdornment={
              csvPreview && (
                <InputAdornment position="start">
                  <a href={csvPreview} download>
                    <DownloadOutlined
                      style={{ color: "#e8442d", cursor: "pointer" }}
                    />
                  </a>
                  <IconButton onClick={() => {
                    setCellData((prev) => {
                      return {
                        ...prev,
                        cell_impedance_csv: "",
                      };
                    });
                    setCsvPreview("");
                  }}>
                    <Clear />
                  </IconButton>
                </InputAdornment>
              )
            }
            sx={{
              '& .MuiInputBase-input': {
                border: '0.1px solid #e8442d',
                borderRadius: '5px',
                padding: '10px',
                color: "#000",
                cursor: 'pointer',
                '&::placeholder': {
                  color: '#e8442d',
                  fontWeight: '900',
                },
              },
              '& .MuiIconButton-root': {
                color: '#e8442d',
              },
              '& .MuiInputBase-root': {
                backgroundColor: 'white',
              },
              '& .MuiInputBase-input::placeholder': {
                color: '#e8442d',
                fontWeight: '900',
              }
            }}
          />

        </div>

        <div className="w-full flex flex-col justify-center items-start gap-1">
          <label className="text-[#e8442d] text-sm p-2 font-thin" htmlFor="cellImpedanceCsv">
            Upload Cell Current HPPC csv *
          </label>
          <Input
            id="cellCurrentHppcCsv"
            required
            type="file"
            fullWidth
            variant="filled"
            multiple={false}
            disableUnderline
            onChange={(e) => {
              const file = e.target.files[0];
              setCellData((prev) => {
                return {
                  ...prev,
                  cell_hppc_csv: file,
                };
              }
              );
              const previewURL = URL.createObjectURL(file);
              setCsvPreview1(previewURL);
              document.getElementById('cellImpedanceCsv').innerText = file.name;
            }}
            error={errors.cell_hppc_csv ? true : false}
            inputProps={{ accept: "text/csv", id: "cellCurrentHppcCsv", style: { color: "#e8442d", fontWeight: "900" }, placeholder: "Upload Cell Current HPPC CSV" }}
            endAdornment={
              csvPreview1 && (
                <InputAdornment position="start">
                  <a href={csvPreview1} download>
                    <DownloadOutlined
                      style={{ color: "#e8442d", cursor: "pointer" }}
                    />
                  </a>
                  <IconButton onClick={() => {
                    setCellData((prev) => {
                      return {
                        ...prev,
                        cell_hppc_csv: "",
                      };
                    });
                    setCsvPreview1("");
                  }}>
                    <Clear />
                  </IconButton>
                </InputAdornment>
              )
            }
            sx={{
              '& .MuiInputBase-input': {
                border: '0.1px solid #e8442d',
                borderRadius: '5px',
                padding: '10px',
                color: "#000",
                cursor: 'pointer',
                '&::placeholder': {
                  color: '#e8442d',
                  fontWeight: '900',
                },
              },
              '& .MuiIconButton-root': {
                color: '#e8442d',
              },
              '& .MuiInputBase-root': {
                backgroundColor: 'white',
              },
              '& .MuiInputBase-input::placeholder': {
                color: '#e8442d',
                fontWeight: '900',
              }
            }}
          />

        </div>

        <div className="w-full flex flex-col justify-center items-start gap-1">
          <label className="text-[#e8442d] text-sm p-2 font-thin" htmlFor="cellImpedanceCsv">
            Upload Cell Cycle csv *
          </label>
          <Input
            id="cellCurrentHppcCsv"
            required
            type="file"
            fullWidth
            variant="filled"
            multiple={false}
            disableUnderline
            onChange={(e) => {
              const file = e.target.files[0];
              setCellData((prev) => {
                return {
                  ...prev,
                  cell_cycle_csv: file,
                };
              }
              );
              const previewURL = URL.createObjectURL(file);
              setCsvPreview1(previewURL);
              document.getElementById('cellImpedanceCsv').innerText = file.name;
            }}
            error={errors.cell_cycle_csv ? true : false}
            inputProps={{ accept: "text/csv", id: "cellCurrentHppcCsv", style: { color: "#e8442d", fontWeight: "900" }, placeholder: "Upload Cell Current HPPC CSV" }}
            endAdornment={
              csvPreview2 && (
                <InputAdornment position="start">
                  <a href={csvPreview1} download>
                    <DownloadOutlined
                      style={{ color: "#e8442d", cursor: "pointer" }}
                    />
                  </a>
                  <IconButton onClick={() => {
                    setCellData((prev) => {
                      return {
                        ...prev,
                        cell_cycle_csv: "",
                      };
                    });
                    setCsvPreview2("");
                  }}>
                    <Clear />
                  </IconButton>
                </InputAdornment>
              )
            }
            sx={{
              '& .MuiInputBase-input': {
                border: '0.1px solid #e8442d',
                borderRadius: '5px',
                padding: '10px',
                color: "#000",
                cursor: 'pointer',
                '&::placeholder': {
                  color: '#e8442d',
                  fontWeight: '900',
                },
              },
              '& .MuiIconButton-root': {
                color: '#e8442d',
              },
              '& .MuiInputBase-root': {
                backgroundColor: 'white',
              },
              '& .MuiInputBase-input::placeholder': {
                color: '#e8442d',
                fontWeight: '900',
              }
            }}
          />

        </div>
        <Button
          fullWidth
          type="submit"
          variant="contained"
          size="large"
          sx={{
            backgroundColor: "#e8442d",
            fontWeight: "900",
            padding: "0.7rem",
            "&:hover": {
              backgroundColor: "#e85d01",
            },
            "&:active": {
              backgroundColor: "#e85d01",
            },
          }}
        >
          Submit
        </Button>
      </form>
    </div>
  );
};
